import { ApiHelper, SortHelper } from '../helpers';
import { SelectItemType, UnidadeSummaryType } from '../types';
import { useEffect, useState } from 'react';

import Axios from 'axios';
import { TipoUnidadeAcademicaEnum } from '../enums';

const useUnidadesAcademicas = (tipoUnidadeAcademica: TipoUnidadeAcademicaEnum | null) => {
  const [centros, setCentros] = useState<SelectItemType[]>([]);

  useEffect(() => {
    Axios.get(ApiHelper.getUrl.apiComum.unidades(), { params: { tipo_academica: tipoUnidadeAcademica } }).then((response) =>
      setCentros(
        response.data
          .map((centro: UnidadeSummaryType) => ({
            label: `${centro.nome}`,
            value: centro.id,
          }))
          .sort(SortHelper.sortOptionsFunction),
      ),
    );
  }, [tipoUnidadeAcademica]);

  return centros;
};

export default useUnidadesAcademicas;
